import { inject, Injectable } from '@angular/core';
import { AyaControllerApiService } from '@lx/shared/api';
import { getLocale } from '@lx/shared/i18n';
import { getCompanyHeader } from '@lx/shared/tokens';
import { sortArray } from '@lx/shared/utils-array';
import { map, Observable } from 'rxjs';
import { GroupedSchoolLocation } from '../types';

@Injectable({
  providedIn: 'root',
})
export class AyaLocationService {
  private readonly ayaControllerApiService = inject(AyaControllerApiService);
  private readonly locale = getLocale();
  private readonly companyHeader = getCompanyHeader();

  getAyaLocations(courseCode: string, languageCode: string): Observable<GroupedSchoolLocation[]> {
    return this.ayaControllerApiService.findAyaLocations(courseCode, this.locale, this.companyHeader, languageCode).pipe(
      map(({ locations }) =>
        locations.map(({ country, schools }) => ({
          label: country.name,
          value: country.code,
          weight: country.weight,
          items: schools.map(({ name, code, weight }) => ({
            label: name,
            value: code,
            weight: weight,
          })),
        })),
      ),
      map(this.sortAyaLocations),
    );
  }

  private sortAyaLocations(ayaLocations: GroupedSchoolLocation[]): GroupedSchoolLocation[] {
    const sortedCoursesTree: GroupedSchoolLocation[] = sortArray<GroupedSchoolLocation>(ayaLocations, [{ property: 'weight' }, { property: 'label' }]);

    sortedCoursesTree.forEach((courseType) => {
      const sortedCourses = sortArray(courseType.items, [{ property: 'weight' }]);
      courseType.items = [...sortedCourses];
    });

    return sortedCoursesTree;
  }
}
